import React from 'react'
import PostSingle from './PostSingle'

export default (props) => {
  console.log(props)
  const postItems = props.data_posts.map((post, i) => {
    return (
      <PostSingle
        key={i} 
        match={props.match.params.id}
        title={post.title.rendered}
        id={post.id}
        content={post.content.rendered}
      />
    )
  });
  return (
    <div data-c="PostList">
      <h3>ID: {props.match.params.id}</h3>
      {postItems}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/posts/PostList.js